export default __webpack_public_path__ + "static/media/ellipse.44cc432e.svg";